import {
  LazySurveyDeprecationNotice,
  LazyNewSurveyButton,
  LazySurveyList,
} from "@/shared/components/LazyComponents";
import SkeletonLoader from "@/shared/components/SkeletonLoader";
import { Suspense } from "react";

const Home = () => (
  <section className="container mx-auto mt-10">
    <Suspense
      fallback={
        <section className="mb-4">
          <SkeletonLoader className="h-6 mb-4 w-full" />
          <ul className="list-disc pl-8">
            <SkeletonLoader count={2} className="h-6 w-full" />
          </ul>
        </section>
      }
    >
      <LazySurveyDeprecationNotice />
    </Suspense>

    <Suspense fallback={null}>
      <LazyNewSurveyButton />
    </Suspense>

    <Suspense
      fallback={
        <SkeletonLoader className="h-18" wrapperClass="gap-1" count={4} />
      }
    >
      <LazySurveyList />
    </Suspense>
  </section>
);

export default Home;
